module.exports = __webpack_public_path__ + "static/media/51.97b249bd.jpg";